import { render } from "./SearchNotaryComponent.vue?vue&type=template&id=705eba97&scoped=true"
import script from "./SearchNotaryComponent.vue?vue&type=script&lang=js"
export * from "./SearchNotaryComponent.vue?vue&type=script&lang=js"

import "./SearchNotaryComponent.vue?vue&type=style&index=0&id=705eba97&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705eba97"]])

export default __exports__